import styled, { css } from 'styled-components';
import {
  ui_black,
  ui_grey40,
  ui_grey60,
  ui_focus,
  bombas_offwhite
} from 'Styles/colors';
import { fontTitle, fontBody } from 'Styles/fonts';
import strikethrough from 'Styles/strikethrough';

export const Input = styled.input`
  opacity: 0;
  position: absolute;
  left: -9999px;
`;

export const Span = styled.span`
  ${fontTitle(16)};
  align-self: center;
  border-radius: 2px;
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-width: 56px;
  padding: 7px 4px 8px 4px;
  text-align: center;
  text-transform: none;
  transition: border-color 200ms cubic-bezier(0, 0.5, 0.1, 1);
  user-select: none;
  width: 100%;
`;

export const Label = styled.label`
  display: flex;
  flex: 1;
  justify-content: center;
  border-radius: 2px;
  background-color: ${bombas_offwhite};
  color: ${ui_grey60};
  box-shadow: 0px 4px 16px 4px rgba(3, 3, 2, 0.01) inset;

  @media (hover: hover) {
    ${Input}:hover:not(:checked):not([disabled]) ~ ${Span} {
      color: ${ui_black};
      border-color: ${ui_grey40};
    }
  }

  ${Input}:checked ~ ${Span} {
    color: ${ui_black};
    border-color: ${ui_black};
  }

  ${Input}:focus-visible ~ ${Span} {
    outline: none;
    border-color: ${ui_focus};
  }

  ${Input}[disabled] ~ ${Span} {
    cursor: not-allowed;
  }

  ${({ isUnavailable, isSelected }) => {
    if (isUnavailable && isSelected)
      return css`
        background-image: ${strikethrough(ui_black, 2)};
      `;

    if (isUnavailable)
      return css`
        background-image: ${strikethrough(ui_grey60, 2)};
        &:hover {
          background-image: ${strikethrough(ui_black, 2)};
        }
      `;
  }}
`;

export const Note = styled.span`
  display: block;
  text-transform: none;
  ${fontBody(14)}
`;
